// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import the vue instance
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import { store } from './store.js'
import axios from 'axios'
import './assets/scss/app.scss'
import router from './router'
import vuetify from '@/plugins/vuetify' // path to vuetify export

import VueFirestore from 'vue-firestore';

Vue.use(VueFirestore);

axios.defaults.baseURL = 'https://jomapp.herokuapp.com'
// axios.defaults.baseURL = 'http://localhost:3000'
Vue.config.productionTip = false

//instatinat the vue instance
new Vue({
//define the selector for the root component
  vuetify,
  el: '#app',
  //pass the template to the root component
  template: '<App/>',
  //declare components that the root component can access
  components: { App },
  //pass in the router to the Vue instance
  router,
  store
}).$mount('#app')//mount the router on the app



// WEBPACK FOOTER //
// ./src/main.js